var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M3.73552 13.4762L3.93241 11.6243L10.1392 6.03569L11.8046 7.88544L5.59788 13.474L3.73552 13.4762ZM12.9658 6.83993L11.3004 4.99018L12.5446 3.86991L14.21 5.71961L12.9658 6.83993ZM2.07144 14.3489C2.03216 14.7185 2.32207 15.0404 2.69369 15.04L5.95898 15.0361C6.11317 15.0359 6.26185 14.9787 6.37644 14.8756L15.9522 6.25346C16.2088 6.02249 16.2295 5.62731 15.9985 5.37079L13.0784 2.1277C12.8474 1.87118 12.4522 1.85047 12.1957 2.08144L2.61993 10.7035C2.50534 10.8067 2.43294 10.9486 2.41664 11.1019L2.07144 14.3489ZM17.9321 16.7673C17.9321 16.6292 17.8202 16.5173 17.6821 16.5173H2.55713C2.41906 16.5173 2.30713 16.6292 2.30713 16.7673V17.8298C2.30713 17.9678 2.41906 18.0798 2.55713 18.0798H17.6821C17.8202 18.0798 17.9321 17.9678 17.9321 17.8298V16.7673Z",
    fill: "#070A26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.df8be840356d7e620f05690dedf0ea57.svg";
export { ForwardRef as ReactComponent };